import Vue from 'vue'
import ClickOutside from 'vue-click-outside'
import {
  decode,
  handleize
} from 'lib/util'
import state from 'lib/appState'
import on from 'dom-event'
import ProductCardMixin from './product-card-mixin'
import select from 'select-dom'

/**
 * This component is used throughout the site,
 * in product carousels and on the PLP page.
 */
Vue.component('product-card', {
  mixins: [ProductCardMixin],
  props: [
    'product',
    'decode',
    'featured',
    'isSubscriptionMode'
  ],
  directives: {
    ClickOutside
  },

  /**
   * Data can come via a JSON string that needs to be
   * decoded, or via an javascript object, passed by a
   * parent component or a Vuex store.
   */
  data () {
    let product
    if (!!this.decode && this.product) {
      product = JSON.parse(decode(this.product))
    } else {
      product = (this.product || {
        title: '',
        price: '',
        featuredImage: '',
        variants: [],
        optionNames: []
      })
    }
    return {
      state,
      quickBuyActive: false,
      loading: false,
      ...product,
      activeOption: '',
      isFocus: false
    }
  },
  computed: {
    isCustomBundle () {
      return handleize(this.type).includes('custom-bundle')
    }
  },
  mounted () {
    this.activeOption = this.activeOptions[0]
    this.isFocus = this.focusInside()
  },
  methods: {
    focusInside () {
      const focusElements = select.all('a, input, button', this.$el)
      if (focusElements) {
        focusElements.map((el, index) => {
          setTimeout(() => {
            el.removeAttribute('tabindex')
          }, 500)
          if (index === 0) {
            on(el, 'focus', () => {
              this.isFocus = true
            })
          }
          on(el, 'keydown', (e) => {
            this.isFocus = !((index === 0 && e.keyCode === 9 && e.shiftKey) || (index === (focusElements.length - 1) && e.keyCode === 9 && !e.shiftKey))
          })
        })
      }
      return this.isFocus
    }
  }
})
